module.exports = __webpack_public_path__ + "static/media/mainpage.3bc44f2f.jpg";